// The founding account retains its complimentary premium status. Paid access is
// granted separately by Stripe webhooks and checked against a signed expiry.
const PREMIUM_EMAILS = new Set(["cmk2012cc@gmail.com"]);

export function isPremiumEmail(email: unknown, emailVerified: unknown): boolean {
  return emailVerified === true && typeof email === "string" && PREMIUM_EMAILS.has(email.trim().toLowerCase());
}

export function hasPaidPremium(premiumUntil: unknown, nowSeconds = Date.now() / 1000): boolean {
  return typeof premiumUntil === "number" && Number.isFinite(premiumUntil) && premiumUntil > nowSeconds;
}

export function isPremiumUser(user: { email?: string | null; emailVerified?: boolean; isAnonymous?: boolean } | null | undefined, premiumUntil?: unknown) {
  return Boolean(user && !user.isAnonymous && (isPremiumEmail(user.email, user.emailVerified) || hasPaidPremium(premiumUntil)));
}

export function premiumTimeLeft(accessUntil: number | null, now = Date.now()): string | null {
  if (!accessUntil || accessUntil <= now) return null;
  const hours = Math.ceil((accessUntil - now) / 3_600_000);
  if (hours < 24) return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  const days = Math.ceil((accessUntil - now) / 86_400_000);
  return `${days} ${days === 1 ? "day" : "days"}`;
}

/** Lobby order: premium players first. Stable sorts keep everyone else's order. */
export function premiumFirst(left: { premium?: boolean }, right: { premium?: boolean }): number {
  return Number(Boolean(right.premium)) - Number(Boolean(left.premium));
}
